<template>
  <div>
    <div class="container pt-5 text-center">
      <div class="lead">
        <div class="text-center py-4">
          <h2>Usluge</h2>
          <div class="row my-3">
            <c-service
              v-for="(x, idx) in services"
              :key="idx"
              :img="x.img"
              :title="x.title"
            />
          </div>
          <hr>
        </div>
        <div class="text-center py-4">
          <h2>Primjeri projekata</h2>
          <div class="row">
            <div v-for="(x, idx) in examples" :key="idx" class="col-sm-3 p-2">
              <c-portfolio-card
                :link="x.link"
                :domain="x.domain"
                :product="x.product"
                :shortdesc="x.shortdesc"
                :img="x.img"
              />
            </div>
          </div>
        </div>
        <div class="py-4">
          <h2>Tehnologije</h2>
          <div class="row my-3">
            <div v-for="(x, idx) in technology" :key="idx" class="col">
              <img
                :src="require(`@/assets/img/technology/${x.img}`)"
                class="card-img-top px-4"
                :alt="x.title"
                :title="x.title"
                style="min-width:100px"
              />
            </div>
          </div>
          <hr>
        </div>
        <div class="py-4">
          <h2>O nama</h2>
          <c-about-us />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cAboutUs from "../components/cAboutUs.vue";
import cCard from "../components/cCard.vue";
import cCallUs from "../components/cCallUs.vue";
import cService from "../components/cService.vue";
import cPortfolioCard from "../components/cPortfolioCard.vue";

export default {
  metaInfo: {
    titleTemplate: "%s | Naslovna",
    meta: [
      {
        name: "description",
        content: "Izrada web stranica i aplikacija - Rijeka.",
      },
    ],
  },
  components: {
    cAboutUs,
    cCard,
    cCallUs,
    cService,
    cPortfolioCard,
  },
  data() {
    return {
      services: [
        { img: "website.svg", title: "Izrada web aplikacija" },
        { img: "browser.svg", title: "Izrada web stranica" },
        { img: "software.svg", title: "Izrada računalnih programa" },
        { img: "seo.svg", title: "SEO optimizacija" },
        { img: "adwords.svg", title: "Adwords kampanja" }
      ],
      examples: [
        {
          link: "https://www.programprehrane.com",
          domain: "programprehrane.com",
          product: "Program Prehrane Web",
          shortdesc: "Web aplikacija za nutricioniste",
          img: "ppw.png",
        },
        {
          link: "https://www.igprog.hr/kup",
          domain: "igprog.hr/kup",
          product: "KUP",
          shortdesc: "Kasa uzajamne pomoće",
          img: "kup.png",
        },
        {
          link: "https://www.dizajn911.com",
          domain: "dizajn911.com",
          product: "Dizajn 911",
          shortdesc: "Studio za dizajn interijera",
          img: "dizajn911.png",
        },
        {
          link: "https://apartmentverano.com",
          domain: "apartmentverano.com",
          product: "Apartment Verano",
          shortdesc: "Apartmani Verano - Njivice",
          img: "apartmentverano.png",
        }
      ],
      technology: [
        { img: "vue-js.jpg", title: "Vue.js" },
        { img: "angular-js.jpg", title: "Angular.js" },
        { img: "net-core.png", title: ".net Core" },
        { img: "net.jpg", title: ".Net" },
        { img: "ms-sql.jpg", title: "MS SQ" },
        { img: "bootstrap4.png", title: "Bootstrap 4" }
      ],
      constants: this.$constants,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/home.vue